import { FormFieldData } from "./types";

export const inputsData: FormFieldData[] = [
  {
    id: 1,
    name: "question1",
    labelKey: "edit.questionLabel"
  },
  {
    id: 2,
    name: "question2",
    labelKey: "edit.questionLabel"
  },
  {
    id: 3,
    name: "question3",
    labelKey: "edit.questionLabel"
  }
];
